import AddressService from "services/Address";
import StorageService from "services/StorageService/";

const getFullAddress = (address) => {
    let addressArray = [];

    if (!address) return null

    addressArray.push(address?.street + ' ' + (address?.number || ''));
    if(address?.complement) addressArray.push(address?.complement);
    if(address?.neighborhood) addressArray.push(address?.neighborhood);
    if(address?.city) addressArray.push(address?.city);
    if(address?.state) addressArray.push(address?.state);

    return addressArray.join(', ');
}

const getAdressesOptions = (adresses) => {
    return adresses.map(address => {
        return {
            label: getFullAddress(address),
            value: address
        };
    }).filter(address => address.label.indexOf('*') === -1).filter(Boolean);
}

const getSla = (logisticsInfo, method = StorageService.getItem('preselected_shipping_method'), addressId = false)=> {
    const sla = (logisticsInfo && logisticsInfo.length) ? logisticsInfo[0].slas.filter(slas => {
        if (slas.id.includes("Click al Auto") && method === 'seller-1-sla-ClickalAuto') {
            return slas
        }

        if ((addressId ? slas.id.includes(addressId) : slas.id.includes("Retiro en Tienda")) && method === 'seller-1-sla-RetiroenTienda') {
            return slas
        }

        if ((slas.id.includes('Despacho a Domicilio') || slas.id.includes('Despacho Especial')) && method === 'seller-1-sla-DespachoaDomicilio') {
            return slas
        }
    }).filter(Boolean) : [];

    return sla;
}


const getFormatedMethod = (method) => {
    switch(method){
        case 'seller-1-sla-RetiroenTienda':
            return "Retiro en Tienda";
        case 'seller-1-sla-ClickalAuto':
            return "Click al Auto";
        case 'seller-1-sla-DespachoaDomicilio':
            return "Despacho a Domicilio";
        case 'seller-1-sla-Express':
            return "Despacho Express";
        default:
            return '';                       
    }
}

const translateAddress = (id) =>{
    return AddressService.get(id).then(results => {
        if (results?.length){
            return results
        }else{
            return Promise.resolve( false)
        }
    })
}

const AddressFactory = {
    getFullAddress,
    getAdressesOptions,
    getSla,
    getFormatedMethod,
    translateAddress,
}

export default AddressFactory;
